import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Tippy from "@tippyjs/react";
import "tippy.js/dist/tippy.css";

import type { ToolConfig } from "types";
import styles from "./ActiveToolChips.module.scss";

const MAX_VISIBLE_CHIPS = 5;

interface ActiveToolChipsProps {
  tools: ToolConfig[];
  isMenuOpen: boolean;
}

export default function ActiveToolChips({
  tools,
  isMenuOpen,
}: ActiveToolChipsProps) {
  const activeTools = tools.filter((tool) => tool.enabled);

  if (activeTools.length === 0 && !isMenuOpen) return null;

  const visibleTools = activeTools.slice(0, MAX_VISIBLE_CHIPS);
  const overflowTools = activeTools.slice(MAX_VISIBLE_CHIPS);

  return (
    <div className={styles.chipRow}>
      {visibleTools.map((tool) => (
        <span key={tool.key} className={styles.chip}>
          <FontAwesomeIcon icon={tool.icon} className={styles.chipIcon} />
          {tool.label}
        </span>
      ))}
      {overflowTools.length > 0 && (
        <Tippy
          content={overflowTools.map((tool) => tool.label).join(", ")}
          placement="top"
        >
          <span className={styles.moreChip}>+{overflowTools.length} more</span>
        </Tippy>
      )}
    </div>
  );
}
